import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import {
  OAuthDetails,
  OAuthResponse,
  IGoogleOAuthCallbackRequest,
} from "../../features/Configurations/Integration/interface";

type Platform = "google_ads" | "google_admob";

interface GetOAuthUrlParams {
  platform: Platform;
  tracking_id?: string;
}

interface CallbackParams {
  code: string;
  platform: Platform;
  tracking_id?: string;
  scope?: string[];
}

export const useGoogleOAuth = () => {
  const getOAuthUrl = useMutation<OAuthDetails, Error, GetOAuthUrlParams, unknown>({
    mutationFn: async ({ platform, tracking_id }) => {
      const url = `${API_CONFIG.path.googleOAuth}/${platform}`;
      const details = await httpService.get<OAuthDetails>(url, tracking_id ? { tracking_id } : undefined);
      return details;
    },
  });

  const handleCallback = useMutation<
    OAuthResponse,
    Error,
    CallbackParams,
    unknown
  >({
    mutationFn: async ({ code, platform, tracking_id, scope }) => {
      const response = await httpService.post<OAuthResponse, IGoogleOAuthCallbackRequest>(
        API_CONFIG.path.googleOAuthCallback,
        {
          code,
          authorise_type: platform,
          ...(tracking_id && { tracking_id }),
          ...(scope && { scope }),
        }
      );
      return response;
    },
  });

  return {
    getOAuthUrl,
    handleCallback,
  };
};
